type PropTypes = {
  text: string
}

const FormError = ({
  text,
}: PropTypes) => {
  return (
    <p className="text-xs text-red-500 mt-2">{text}</p>
  )
}

export default FormError